//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { t } from 'element-ui/lib/locale';
export default {
  name: "profileInfo",
  props: {
    record: {
      type: Object,
      default: () => ({}),
    },
    rules: {
      type: Object,
      default: () => ({}),
    },
    appellationList: {
      type: Array,
      default: () => [],
    },
    suffixList: {
      type: Array,
      default: () => [],
    },
    genderList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      showUpdate: true, //是否更新
      saveUrl: "api/api/portalLogin/savePortalUserTemp",
    };
  },
  methods: {
    changeBtn() {
      //点击更新按扭时
      this.showUpdate = false;
    },
    savePortalUser() {
      //保存按扭
      this.saveForm("save");
    },
    async submitPortalUser() {
      let check = await this.checkSubmit();
      if (check) {
        //提交按扭
        this.saveUrl = "api/api/portalLogin/savePortalUser";
        this.$msgDailog.showMsgBox({
          title: "Are you sure to proceed with the changes?",
          ifcancel: true,
        }).then(async (val) => {
          //点击确定触发事件 val:返回文本域内容
          this.saveForm("submit"); 
        }).catch(() => {
          // ... 点击取消触发事件 已隐藏
        });
      }
    },
    saveForm(act) {
      //保存表单数据
      let params = {
        record: this.record,
      };
      this.axios
        .post(this.saveUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            let msg = data.data.msg;
            if (act == "save" && !this.isNotNullOrEmpty(msg)) {
              return;
            }
            this.$msgDailog.showMsgBox({
              // title: msg
              title: "Submit Successfully",
            });
            this.showUpdate = true;
          }
        })
        .catch((error) => console.log(error));
    },

    changeList(val, type) {
      let list = [], name = '';
      if (type == 'Appellation') {
        list = this.appellationList;
      } else if (type == 'Suffix') {
        list = this.suffixList;
      } else if (type == 'Gender') {
        list = this.genderList;
      }
      for (var i = 0; i < list.length; i++) {
        if (val == list[i].propertyValue) {
          name = list[i].propertyLabel;
        }
      }
      if (type == 'Appellation') {
        this.$set(this.record, 'appellationname', name);
      } else if (type == 'Suffix') {
        this.$set(this.record, 'suffixname', name);
      } else if (type == 'Gender') {
        debugger
        this.$set(this.record, 'gendername', name);
      }
    },

    async checkSubmit() {
      let firstname = this.record.firstname;
      let lastname = this.record.lastname;
      let middlename = this.record.middlename; 
      let birthday = this.record.birthday;
      let phone = this.record.phone;
      let address = this.record.address;
      let emailaddress = this.record.emailaddress;
      if (!this.isNotNullOrEmpty(firstname)) {
        this.$msgDailog.showMsgBox({
          title: "First Name Required",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(lastname)) {
        this.$msgDailog.showMsgBox({
          title: "Last Name Required",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(middlename)) {
        this.$msgDailog.showMsgBox({
          title: "Middle Name Required",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(birthday)) {
        this.$msgDailog.showMsgBox({
          title: "Date of Birth Required",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(phone)) {
        this.$msgDailog.showMsgBox({
          title: "Phone Number Required",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(address)) {
        this.$msgDailog.showMsgBox({
          title: "Address Required",
        });
        return false;
      }
      if (!this.isNotNullOrEmpty(emailaddress)) {
        this.$msgDailog.showMsgBox({
          title: "Email Address Required",
        });
        return false;
      }
      return true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/profileInfo.vue